module.exports = __webpack_public_path__ + "img/3.9af6ed77.png";